import { render, staticRenderFns } from "./AutomationWizardOverviewDescription.vue?vue&type=template&id=35290052&scoped=true&"
import script from "./AutomationWizardOverviewDescription.vue?vue&type=script&lang=js&"
export * from "./AutomationWizardOverviewDescription.vue?vue&type=script&lang=js&"
import style0 from "./AutomationWizardOverviewDescription.vue?vue&type=style&index=0&id=35290052&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35290052",
  null
  
)

export default component.exports